import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/login',
            component: resolve => require(['./views/login.vue'], resolve)
        },
        {
            path:'/home',
            name:'home',
            component:resolve => require(['./views/home.vue'], resolve)
        },
        {
          path:'/query',
          name:'query',
          component:resolve => require(['./components/container.vue'], resolve),
          children:[
            {
              path:'',
              redirect:'chat-query/by-user'
            },
            {
              path:'chat-query',
              redirect:'chat-query/by-user'
            },
            {
              path:'chat-query/by-user',
              component:resolve => require(['./views/query/chat_query_by_user.vue'], resolve)
            },
            {
              path:'chat-query/by-event',
              component:resolve => require(['./views/query/chat_query_by_event.vue'], resolve)
            },
            {
                path: 'monitor',
                redirect: 'monitor/list'
            },
            {
                path: 'monitor/list',
                component: resolve => require(['./views/monitor/list.vue'], resolve)
            }
          ]
        },
        {
            path: '/app/:system',
            component:resolve => require(['./components/container.vue'], resolve),
            children:[
                {
                    path: 'overview',
                    component: resolve => require(['./views/app/tb_user_overview.vue'], resolve)
                },
                {
                    path: 'revenue',
                    component: resolve => require(['./views/app/tb_rev_overview.vue'], resolve)
                },
                {
                    path: 'user/event',
                    component: resolve => require(['./views/app/user_event.vue'], resolve)
                },
                {
                    path: 'etp/events',
                    component: resolve => require(['./views/app/etp_events.vue'], resolve)
                },
                {
                    path: 'etp/event/view',
                    component: resolve => require(['./views/app/etp_events_view.vue'], resolve)
                },
                {
                    path: 'etp/event/verify',
                    component: resolve => require(['./views/app/etp_events_check.vue'], resolve)
                },
                {
                    path: 'etp/users',
                    component: resolve => require(['./views/app/etp_user.vue'], resolve)
                },
                {
                    path: 'etp/devices',
                    component: resolve => require(['./views/app/etp_device.vue'], resolve)
                },
                {
                    path: 'etp/event/trend',
                    component: resolve => require(['./views/app/event_trend.vue'], resolve)
                },
                {
                    path: 'etp/event/funnel',
                    component: resolve => require(['./views/app/event_funnel.vue'], resolve)
                },
            ]
        },
        {
            path:'/',redirect:'/login'
        },
        {
            path:'/ams/admin',
            component:resolve => require(['./components/container.vue'], resolve),
            children:[
                {
                    path:'account/list',
                    component:resolve => require(['./views/admin/adminlist.vue'], resolve)
                },
                {
                    path:'add/account',
                    component:resolve => require(['./views/admin/addaccount.vue'], resolve)
                },
                {
                    path:'account/edit/:id',
                    name:'account_edit',
                    component:resolve => require(['./views/admin/addaccount.vue'], resolve)
                },
                {
                    path:'role/list',
                    component:resolve => require(['./views/admin/rolelist.vue'], resolve)
                },
                {
                    path:'role/edit/:id',
                    name:'role_edit',
                    component:resolve => require(['./views/admin/addrole.vue'], resolve)
                },
                {
                    path:'add/role',
                    component:resolve => require(['./views/admin/addrole.vue'], resolve)
                },
                {
                    path:'module/list',
                    component:resolve => require(['./views/admin/modules.vue'], resolve)
                },
                {
                    path: 'app/list',
                    component:resolve => require(['./views/app/list.vue'], resolve),
                    props: { isAdmin: true }
                }
            ]
        },
        {
            path: '/ams/config',
            component:resolve => require(['./components/container.vue'], resolve),
            children:[
                {
                    path:'package',
                    component:resolve => require(['./views/config/packagelist.vue'], resolve)
                },
                {
                    path:'word',
                    component:resolve => require(['./views/config/wordlist.vue'], resolve)
                }
            ]
        },
        {
            path: '/ams/service',
            component:resolve => require(['./components/container.vue'], resolve),
            children:[
                {
                    path: 'cost',
                    component:resolve => require(['./views/finance/service_cost.vue'], resolve)
                },
                {
                    path: 'usage',
                    component:resolve => require(['./views/finance/service_usage.vue'], resolve)
                }
            ]
        },
        {
            path: '/ams/app',
            component:resolve => require(['./components/container.vue'], resolve),
            children: [
                {
                    path: 'list',
                    component:resolve => require(['./views/app/list.vue'], resolve),
                    props: { isAdmin: false }
                }
            ]
        },
    ]
})

